var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app","data-app":""}},[(
      _vm.$route.name !== 'Login' &&
        _vm.$route.name !== 'Signup' &&
        _vm.$route.name !== 'Book' &&
        _vm.$route.name !== 'CompeleteBooking' &&
        _vm.$route.name !== 'NotFound'
    )?_c('div',[_c('Navbar'),_c('div',{staticClass:"wrapper"},[_c('div',{attrs:{"id":"content-wrapper"}},[_c('router-view')],1)])],1):_c('div',[_c('div',{attrs:{"id":"login-wrapper"}},[_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }